import React, { Component } from 'react'
import { connect } from 'react-redux'

import General from '../components/SolicitudServicio/General'
import Proveedores from '../components/SolicitudServicio/Proveedores'
import Cotizaciones from '../components/SolicitudServicio/Cotizaciones'
import Aprobaciones from '../components/SolicitudServicio/Aprobaciones'
import Documentos from '../components/SolicitudServicio/Documentos'
import Cancelacion from "../components/SolicitudServicio/Cancelacion";
import CompraDirecta from '../components/SolicitudServicio/CompraDirecta'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'

//import { getSolicitud, updateSolicitudServicio } from '../actions/solicitudservicio'
import { getSolicitud, updateSolicitudServicio, registerCancelacion } from '../actions/solicitudservicio'
import history from '../utils/history'


import { 
    canmbiarResponsable,
    showModalConfirmarAccion,
    getParameterByName
} from '../actions/common'

import { isAllowedToViewComponent } from '../utils/helpers'



class SolicitudServicio extends Component {
	constructor(props) {
		super(props)
		this.state = {
			tabs: [
				{ id: 0, caption: 'Solicitud', component: <General />, estado: 1 },
                { id: 1, caption: 'Proveedores', component: <Proveedores />, estado: 1 },
                { id: 2, caption: 'Cotizaciones', component: <Cotizaciones />, estado: 2 },
                { id: 3, caption: 'Aprobaciones', component: <Aprobaciones />, estado: 3 },
                { id: 4, caption: 'Documentos', component: <Documentos />, estado: 4 },
                { id: 5, caption: 'Cancelación', component: <Cancelacion />, estado: 0 },
                { id: 6, caption: 'Compra directa', component: <CompraDirecta />, estado: 4 },
                
                
			],
			selected: 0
		}
	}

    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.getSolicitud(this.props.match.params.id)
            const params = new URLSearchParams(this.props.location.search);
            if (params.has("aprobacion")) {
                this.setState({selected: 3})
            }
            this.props.getParameterByName('DIVISAS')
        } else {
            history.push(window.FOLDER + '/solicitudes')
        }
    }

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }
    
    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar la solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.registerCancelacion() })
    }

	render() {
        
		const { tabs, selected } = this.state
        const { btnSaveDisabled, estado, btnRComprasDisabled, solicitud, aprobadores } = this.props
        const readOnly = !isAllowedToViewComponent('responsable_compras', solicitud) 
        const documentos_proceso = solicitud.get('documentos') ? solicitud.get('documentos').filter(d => d.get('estado') == 4 || d.get('estado') > 6).count() : 0
        const facturas_directas = solicitud.get('servicios') ? solicitud.get('servicios').filter(b => b.get('factura_compra_directa_servicios') && b.get('compra_directa')).count() : 0

        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.updateSolicitudServicio() } title="Actualizar solicitud" disabled={ btnSaveDisabled } />,
            <BoxButton key="ba[0][2]" name="user" onClick={ () => this.props.canmbiarResponsable(solicitud, 'ACTUALIZAR_SOLICITUD_SERVICIO') } title="Cambiar responsable" disabled={ btnRComprasDisabled || selected !== 0 } />,
            <BoxButton key="ba[0][3]" name="ban" onClick={() => this.cancel()} title="Aprobar cancelación solicitud" disabled={ readOnly || selected !== 5 || estado == 0} />
        ]

		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                   tabs.filter(x => {

                                        if (solicitud.get('documentos') && x.id === 4 && solicitud.get('documentos').count() === 0) return null;

                                        if (x.id === 3 && aprobadores.count() === 0) return null;

                                        if (estado == 1) {
                                            return x.id == 0 || x.id == 1 || x.id == 5
                                        } else if ((documentos_proceso > 0 || facturas_directas > 0) && x.id === 5) {
                                            return null;
                                        } else if (estado >= 2) {
                                            return x.estado <= estado
                                        } else if (estado == 0) {
                                            return ((x.id == 0) || (x.id == 5))
                                        }


                                    }).map(x => {
                                        return (
                                            <li key={`li01[${x.id}]`} className={selected === x.id ? 'active' : ''}>
                                                <a onClick={(e) => this.selectTab(e, x.id)}>{x.caption}</a>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={ boxActions } />
                            </div>
                            <div className="nav-main-section-scrollable"> 
                            {/* {`${selected == 2 || selected == 3 ? 'table-section-scrollable' : 'nav-main-section-scrollable'}`}> */}
                                { tabs[selected].component }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        btnSaveDisabled: state.solicitudservicio.get('btnSaveDisabled'),
        btnRComprasDisabled: state.solicitudservicio.get('btnRComprasDisabled'),
        estado: state.solicitudservicio.get('estado'),
        solicitud: state.solicitudservicio.get('solicitud'),
        aprobadores: state.solicitudservicio.get('aprobadores')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        updateSolicitudServicio: () => dispatch(updateSolicitudServicio()),
        canmbiarResponsable: (solicitud, type) => dispatch(canmbiarResponsable(solicitud, type)),
        registerCancelacion: () => dispatch(registerCancelacion()),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudServicio)


// WEBPACK FOOTER //
// ./src/containers/SolicitudServicio.jsx